import { styled } from '../Stitches';

const Scale = styled('div', {
  transitionDuration: '0.13s',
  transitionProperty: 'all',

  variants: {
    size: {
      sm: { '&:hover': { transform: 'scale(1.01)' }, '&:active': { transform: 'scale(1)' } },
      md: { '&:hover': { transform: 'scale(1.05)' }, '&:active': { transform: 'scale(1)' } },
      lg: { '&:hover': { transform: 'scale(1.10)' }, '&:active': { transform: 'scale(1)' } },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export default Scale;
